// src/oura/components/plan/CoversMark.tsx
//
// How a plan line is proven, as one small mark: a scan icon when the site
// scan's checks read it ("Site scan checks it"), a person when the team
// confirms it by hand ("We confirm it"). The key line on the plan card is its
// legend, and the line's drawer says it in full. Decorative: the words reach
// a screen reader through the row's srStatus and the key line, so the
// tooltip's wrapper is hidden too, or its title would join the row's name.

import { ScanSearchIcon, UserCheckIcon } from "lucide-react";
import { cn } from "../../lib/cn";
import { AREA_TEXT } from "@oura/ui";
import { coversWords, isCovered, type DraftLine } from "./planModel";

/** The icon alone: teal scan (the site's colour) or purple person (people). */
export function CoversIcon({ covered, className }: { covered: boolean; className?: string }) {
    const Icon = covered ? ScanSearchIcon : UserCheckIcon;
    return <Icon aria-hidden size={14} strokeWidth={2} className={cn("shrink-0", AREA_TEXT[covered ? "site" : "people"], className)} />;
}

/** The row's mark, with its words on hover. */
export function CoversMark({ line }: { line: Pick<DraftLine, "covers" | "reported_by_hand"> }) {
    return (
        <span aria-hidden title={coversWords(line)} className="inline-flex">
            <CoversIcon covered={isCovered(line)} />
        </span>
    );
}
